import { useState, useEffect } from "react";
import format from "date-fns/format";
import tr from "date-fns/locale/tr";
import differenceInDays from "date-fns/differenceInDays";

const useDateHandler = (
  filterForm,
  setFilterForm,
  selectedDatesFilter,
  setSelectedDatesFilter,
  setShowCalendar,
  setDates
) => {
  const [dayStart, setDayStart] = useState("");
  const [dayEnd, setDayEnd] = useState("");
  const [monthStart, setMonthStart] = useState("");
  const [monthEnd, setMonthEnd] = useState("");

  const { startDate, endDate } = selectedDatesFilter?.[0] || {};

  useEffect(() => {
    if (tr) {
      setDayStart(format(startDate, "dd"));
      setDayEnd(format(endDate, "dd"));
      setMonthStart(format(startDate, "MMM", { locale: tr }));
      setMonthEnd(format(endDate, "MMM", { locale: tr }));
    }
  }, [tr, selectedDatesFilter]);

  function handleDateChange(item) {
    const startDate = item.selection.startDate;
    const endDate = item.selection.endDate;
    setDayStart(format(startDate, "dd"));
    setDayEnd(format(endDate, "dd"));
    setMonthStart(format(startDate, "MMM", { locale: tr }));
    setMonthEnd(format(endDate, "MMM", { locale: tr }));
    setSelectedDatesFilter([item.selection]);

    const totalDays = differenceInDays(endDate, startDate);

    if (startDate !== endDate && totalDays > 2) {
      setFilterForm({
        ...filterForm,
        start: format(startDate, "yyyy-MM-dd"),
        end: format(endDate, "yyyy-MM-dd"),
      });
      setShowCalendar && setShowCalendar(false);
      setDates &&
        setDates(
          format(startDate, "yyyy-MM-dd"),
          format(endDate, "yyyy-MM-dd")
        );
    }
  }

  return {
    selectedDatesFilter,
    dayStart,
    dayEnd,
    monthStart,
    monthEnd,
    handleDateChange,
  };
};

export default useDateHandler;
